// src/components/RequireSpecificEmails/RequireSpecificEmails.jsx
import React from "react";
import { useSelector } from "react-redux";
import {
    Navigate,
    Outlet,
    useLocation,
    useNavigate,
} from "react-router-dom";
import { Box, Button, Container } from "@mui/material";

export const specificUserEmails = (process.env.REACT_APP_SPECIFIC_USER_EMAILS || "")
    .split(",")
    .map(email => email.trim().toLowerCase())
    .filter(email => email);

const RequireSpecificEmails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const userEmail = useSelector(state => state.auth?.userAccount?.username?.toLowerCase());

    const redirectToHomeDashboard = () => {
        navigate("/dashboard");
    };

    const isAllowed = specificUserEmails.includes(userEmail);

    return isAllowed ? (
        <Outlet />
    ) : userEmail ? (
        <Container>
            <Box
                sx={{
                    height: 420,
                    marginTop: "4rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "auto",
                }}
            >
                <h3 style={{ fontWeight: "bold" }}>Unauthorized Access</h3>
                <p style={{ marginTop: "1rem", marginBottom: "3rem" }}>
                    You are not authorized to access this page. Please return to the home dashboard.
                </p>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#008080",
                        "&:hover": {
                            backgroundColor: "#008080",
                        },
                    }}
                    onClick={redirectToHomeDashboard}
                >
                    Go to home dashboard
                </Button>
            </Box>
        </Container>
    ) : (
        <Navigate to={"/"} state={{ from: location }} replace />
    );
};

export default RequireSpecificEmails;
